import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import MobileNavigation from '../mobile-navigation/MobileNavigation';
import UserMenu from '../user-menu/UserMenu';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';
import { toggleSidebar } from '../../../redux/sidebar/sidebarReducer';
import SupportSection from '../support-section/SupportSection';

import scss from './MobileMenu.module.scss';

function MobileMenu() {
  const dispatch = useDispatch();
  const { t } = useTranslation('sidebar');

  const handleCloseMenu = () => {
    dispatch(toggleSidebar());
  };

  return (
    <div className={scss.wrapper}>
      <div className={scss.closeWrapper}>
        <button type='button' className={scss.closeButton} onClick={handleCloseMenu} aria-label={t('closeMenu')}>
          <Icon icon={ICONS.Cross} className={scss.closeIcon} />
        </button>
      </div>

      <MobileNavigation onCloseMenu={handleCloseMenu} />

      <UserMenu />

      <SupportSection />
    </div>
  );
}

export default MobileMenu;
